import { CircularProgress, Stack } from '@mui/material'
import { Typography } from 'ComponentLibrary'

type LoadingIndicatorProps = { isPending: boolean; secondaryLoading?: boolean; title?: string; height?: number }
/**
 *
 * @param secondaryLoading: if this field is given as a boolean it will color the loading indicator.
 * When false the indicator will be green, indicating that the action being loaded has succeeded.
 * @param height: height in rem
 * @returns
 */
const LoadingIndicator = ({ isPending, secondaryLoading, title, height = 1.5 }: LoadingIndicatorProps) => {
    const adjustment = height / 2
    return (
        <Stack direction={'row'} alignItems="center">
            {isPending && title && (
                <Typography variant="bodyTextSmall" style={{ marginRight: 10 }}>
                    {title}
                </Typography>
            )}
            <div style={{ position: 'relative', height: 'fit-content', width: '2rem' }}>
                {isPending && (
                    <CircularProgress
                        color={secondaryLoading === false ? 'success' : 'primary'}
                        sx={{ left: `calc(50% - ${adjustment}rem)`, top: `calc(50% - ${adjustment}rem)` }}
                        size={`${height}rem`}
                    />
                )}
            </div>
        </Stack>
    )
}

export default LoadingIndicator
